import type { ReactElement, Ref } from 'react';
import { cn } from '@/ui/lib/utils';
import { ModalHeader } from '../ModalHeader/ModalHeader';
import { ModalBody } from '../ModalBody/ModalBody';
import './modalContent.css';

interface ModalContentProps {
    children: [ReactElement<typeof ModalHeader>, ReactElement<typeof ModalBody>];
    gap?: 'xs' | 'lg';
    ref?: Ref<HTMLDivElement>;
    className?: string;
}

export const ModalContent = ({ className, children, ref, gap = 'xs' }: ModalContentProps) => {
    return (
        <div className={cn('modal-content', `modal-content--gap-${gap}`, className)} ref={ref}>
            {children}
        </div>
    );
};
